<template>
  <div class='maturity-factors'
    :class='{ "is-chart": mode === "chart" }'>
    <svg viewBox='0 0 300 246'>
      <g class='out'>
        <path d='M105 195.885l-45-77.943L105 40h90l45 77.942-45 77.943h-90zm15.577-25.981l-14.422 24.981h87.69l-14.422-24.981h-58.846zm89.134-51.462l-29.422 50.962 14.422 24.981 43.846-75.943h-28.846zm-90 50.962l-29.422-50.962H61.443l43.846 75.943 14.422-24.981zm15.866-25.481l-14.422 24.981h57.69l-14.422-24.981h-28.846zm-.866-.5l-14.422-24.981H91.443l28.846 49.962 14.422-24.981zm45-24.981l-14.422 24.981 14.422 24.981 28.846-49.962h-28.846zm-43.556 24.481h27.69L150 118.942l-13.845 23.981zm14.711-24.481l13.845 23.981 13.846-23.981h-27.691zm-1.732 0h-27.691l13.846 23.981 13.845-23.981zm31.155-51.961l29.422 50.961h28.846L194.711 41.5l-14.422 24.981zm-15 25.981l14.422 24.98h28.846l-28.846-49.961-14.422 24.981zm-14.423 24.98h27.691l-13.846-23.98-13.845 23.98zm-15.577-23.98l-13.846 23.98h27.691l-13.845-23.98zm-43.846 23.98h28.846l14.422-24.98-14.422-24.981-28.846 49.961zm-30 0h28.846l29.422-50.961L105.289 41.5l-43.846 75.942zm102.402-24.48h-27.69L150 116.942l13.845-23.98zm-28.268-1h28.846l14.422-24.981h-57.69l14.422 24.981zM106.155 41l14.422 24.981h58.846L193.845 41h-87.69z'/>
        <path d='M178.01 104.096c-.453 0-.848-.075-1.184-.224a3.163 3.163 0 01-.912-.616l.744-.888c.213.192.427.341.64.448.213.107.445.16.696.16.288 0 .516-.067.684-.2.168-.133.252-.325.252-.576v-.016a.652.652 0 00-.276-.56c-.184-.133-.423-.2-.716-.2-.176 0-.343.02-.5.06-.157.04-.303.089-.436.148l-.712-.472.16-2.76h3.44v1.08h-2.384l-.064.968c.112-.027.224-.049.336-.068a2.43 2.43 0 01.4-.028c.272 0 .527.035.764.104.237.069.445.176.624.32.179.144.319.329.42.556.101.227.152.497.152.812v.016c0 .299-.051.567-.152.804-.101.237-.244.44-.428.608a1.9 1.9 0 01-.672.388 2.674 2.674 0 01-.876.136zm25.088-13.88c-.374 0-.714-.073-1.02-.22a2.301 2.301 0 01-.784-.608 2.785 2.785 0 01-.5-.916 3.553 3.553 0 01-.176-1.136v-.016c0-.405.06-.784.18-1.136a2.84 2.84 0 01.508-.92 2.299 2.299 0 011.808-.84c.368 0 .705.073 1.012.22.306.147.568.349.784.608.216.259.384.564.504.916.12.352.18.731.18 1.136v.016a3.5 3.5 0 01-.18 1.136 2.86 2.86 0 01-.508.92 2.305 2.305 0 01-1.808.84zm-4.864-4.488l-.976.24-.256-1.008 1.608-.48h.84v5.64h-1.216v-4.392zm4.88 3.376a.977.977 0 00.504-.132 1.21 1.21 0 00.384-.368c.106-.157.188-.344.244-.56.056-.216.084-.452.084-.708v-.016c0-.256-.03-.492-.088-.708a1.867 1.867 0 00-.252-.564c-.11-.16-.24-.285-.392-.376a.956.956 0 00-.5-.136.972.972 0 00-.504.132c-.15.088-.276.211-.38.368a1.9 1.9 0 00-.244.56 2.681 2.681 0 00-.088.708v.016c0 .256.029.493.088.712.058.219.141.407.248.564.106.157.236.281.388.372a.969.969 0 00.508.136zm22.462-14.958c-.453 0-.848-.075-1.184-.224a3.163 3.163 0 01-.912-.616l.744-.888c.213.192.427.341.64.448.213.107.445.16.696.16.288 0 .516-.067.684-.2.168-.133.252-.325.252-.576v-.016a.652.652 0 00-.276-.56c-.184-.133-.423-.2-.716-.2-.176 0-.343.02-.5.06-.157.04-.303.089-.436.148l-.712-.472.16-2.76h3.44v1.08h-2.384l-.064.968c.112-.027.224-.049.336-.068a2.43 2.43 0 01.4-.028c.272 0 .527.035.764.104.237.069.445.176.624.32.179.144.319.329.42.556.101.227.152.497.152.812v.016c0 .299-.051.567-.152.804-.101.237-.244.44-.428.608a1.9 1.9 0 01-.672.388 2.674 2.674 0 01-.876.136zm-4.392-4.488l-.976.24-.256-1.008 1.608-.48h.84v5.64h-1.216v-4.392z'/>
      </g>
      <g>
        <g class='lob is-orange'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[0] === 15
          }'
          @click='$emit("select", "leadership")'>
          <text
            x='49.12'
            y='14.424'
            font-size='10'>
            Leadership
          </text>
          <path class='lig is-orange'
            d='M93.48 28.024c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M93.48 28.024c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='77.5'
            y='30.704'
            font-size='8'
            text-anchor='middle'>
            {{ score[0] }}/15
          </text>
        </g>
        <g class='lob is-blue'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[1] === 15
          }'
          @click='$emit("select", "tools")'>
          <text
            x='197.135'
            y='15.9'
            font-size='10'>
            Tools
          </text>
          <path class='lig is-blue'
            d='M227 28.024c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M227 28.024c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='211'
            y='30.704'
            font-size='8'
            text-anchor='middle'>
            {{ score[1] }}/15
          </text>
        </g>
        <g class='lob is-green'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[2] === 15
          }'
          @click='$emit("select", "data")'>
          <text
            x='247.99'
            y='117.488'
            font-size='10'>
            Data
          </text>
          <path class='lig is-green'
            d='M276 129.596c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M276 129.596c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='260'
            y='132.276'
            font-size='8'
            text-anchor='middle'>
            {{ score[2] }}/15
          </text>
        </g>
        <g class='lob is-amber'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[3] === 15
          }'
          @click='$emit("select", "ecosystem")'>
          <text
            x='193.77'
            y='216.311'
            font-size='10'>
            Ecosystem
          </text>
          <path class='lig is-amber'
            d='M237.305 229.99c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M237.305 229.99c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='221.3'
            y='232.67'
            font-size='8'
            text-anchor='middle'>
            {{ score[3] }}/15
          </text>
        </g>
        <g class='lob is-indigo'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[4] === 15
          }'
          @click='$emit("select", "organizational-process")'>
          <text
            x='30.621'
            y='207.2'
            font-size='10'>
            Organizational
          </text>
          <text
            x='48.496'
            y='217.87'
            font-size='10'>
            Process
          </text>
          <path class='lig is-indigo'
            d='M84.075 229.99c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M84.075 229.99c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='68.1'
            y='232.67'
            font-size='8'
            text-anchor='middle'>
            {{ score[4] }}/15
          </text>
        </g>
        <g class='lob is-purple'
          :class='{
            "is-widget": mode === "widget",
            "is-active": score[5] === 15
          }'
          @click='$emit("select", "team-capability")'>
          <text
            x='16.22'
            y='105.288'
            font-size='10'>
            Team
          </text>
          <text
            x='4.27'
            y='115.958'
            font-size='10'>
            Capability
          </text>
          <path class='lig is-purple'
            d='M46.39 129.596c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8z'/>
          <path d='M46.39 129.596c0-4.415-3.585-8-8-8h-16c-4.415 0-8 3.585-8 8s3.585 8 8 8h16c4.415 0 8-3.585 8-8zm-1 0c0 3.863-3.137 7-7 7h-16c-3.863 0-7-3.137-7-7s3.137-7 7-7h16c3.863 0 7 3.137 7 7z'/>
          <text
            x='30.4'
            y='132.276'
            font-size='8'
            text-anchor='middle'>
            {{ score[5] }}/15
          </text>
        </g>
      </g>
      <path class='grp'
        fill-opacity='0.1'
        stroke-width='2'
        stroke-linejoin='round'
        :d='`M${points[0].x},${points[0].y}L${points[1].x},${points[1].y}L${points[2].x},${points[2].y}L${points[3].x},${points[3].y}L${points[4].x},${points[4].y}L${points[5].x},${points[5].y}L${points[0].x},${points[0].y}Z`'/>
    </svg>
  </div>
</template>

<script>
  import { computed } from 'vue'

  export default {
    props: {
      data: Array,
      mode: String
    },

    emits: ['select'],

    setup (props) {
      let score = computed(() => props.data)

      let points = computed(() => {
        let score = props.data
        let points = []
        let originX = 150
        let originY = 117.95
        let length = 90

        for (let i = 0; i < 6; i += 1) {
          let angle = (i * 60 - 120) * Math.PI / 180
          points.push({
            x: originX + score[i] / 15 * length * Math.cos(angle),
            y: originY + score[i] / 15 * length * Math.sin(angle)
          })
        }

        return points
      })

      return { score, points }
    }
  }
</script>

<style lang='scss' scoped>
  @use 'sass:map';
  @use '@/styles/variables';

  .maturity-factors {
    &.is-chart {
      pointer-events: none;
    }
  }

  .out {
    fill: map.get(variables.$colors, 'gray', '300');
  }

  .lob {
    font-weight: map.get(variables.$font-weights, 'bold');
    cursor: default;

    @each $name in 'orange', 'blue', 'green', 'amber', 'indigo', 'purple' {
      &.is-#{$name} {
        fill: map.get(variables.$colors, $name, '500');
      }
    }

    &.is-widget {
      opacity: 0.4;
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;

      &:hover {
        opacity: 1;
      }

      &.is-active {
        opacity: 1;
      }
    }
  }

  .lig {
    @each $name in 'orange', 'blue', 'green', 'amber', 'indigo', 'purple' {
      &.is-#{$name} {
        fill: map.get(variables.$colors, $name, '300');
      }
    }
  }

  .grp {
    fill: map.get(variables.$colors, 'primary', '500');
    stroke: map.get(variables.$colors, 'primary', '500');
  }
</style>
